<template>
<div class="container">
    <div class="row">
        <div class="col-lg-10 offset-lg-1 legend">
            <div class="">
                <p><span class="dot light"> </span>O MĂSURĂ FORMULA Aptamil<sup>®</sup> NUTRI-BIOTIK<sup>™</sup></p>
            </div>
            <div class="">
                <p><span class="dot dark"> </span>O MĂSURĂ FORMULA ANTERIOARĂ</p>
            </div>
        </div>
    </div>
    <div class="row grafic-formula">
        <div class="col-lg-10 offset-lg-1">
            <div class="row">
                <div class="col-lg-4 pt-1">
                    <div class="border-light">
                        <span class="pr-4"> ZIUA 1-3 </span>
                        <p><span class="dot light"></span> <span class="dot dark"> </span>
                            <span class="dot dark"> </span> <span class="dot dark"> </span> <span class="dot dark"> </span> <span class="dot dark"> </span></p>
                    </div>
                </div>
                <div class="col-lg-4 pt-1">
                    <div class="border-light">
                        <span class="pr-4"> ZIUA 4-6</span>
                        <p><span class="dot light"></span> <span class="dot light"> </span>
                            <span class="dot dark"> </span> <span class="dot dark"> </span> <span class="dot dark"> </span> <span class="dot dark"> </span></p>
                    </div>
                </div>
                <div class="col-lg-4 pt-1">
                    <div class="border-light">
                        <span class="pr-4"> ZIUA 7-9</span>
                        <p><span class="dot light"></span> <span class="dot light"> </span>
                            <span class="dot light"> </span> <span class="dot dark"> </span> <span class="dot dark"> </span> <span class="dot dark"> </span></p>
                    </div>
                </div>
            </div>

            <div class="row pt-4">
                <div class="col-lg-4 pt-1">
                    <div class="border-light">
                        <span class="pr-4">ZIUA 10-12 </span>
                        <p><span class="dot light"></span> <span class="dot light"> </span>
                            <span class="dot light"> </span> <span class="dot light"> </span> <span class="dot dark"> </span> <span class="dot dark"> </span></p>
                    </div>
                </div>
                <div class="col-lg-4 pt-1">
                    <div class="border-light">
                        <span class="pr-4"> ZIUA 13-15 </span>
                        <p><span class="dot light"></span> <span class="dot light"> </span>
                            <span class="dot light"> </span> <span class="dot light"> </span> <span class="dot light"> </span> <span class="dot dark"> </span></p>
                    </div>
                </div>
                <div class="col-lg-4 pt-1">
                    <div class="border-light">
                        <span class="pr-4">ZIUA 16-18</span>
                        <p><span class="dot light"></span> <span class="dot light"> </span>
                            <span class="dot light"> </span> <span class="dot light"> </span> <span class="dot light"> </span> <span class="dot light"> </span></p>
                    </div>
                </div>
            </div>


        </div>
    </div>
</div>
</template>

<script>
export default {
    components: {},
    data() {
        return {}
    },
}
</script>

<style>

</style>
